import apiUrl from '../../../utils/settings';

export const LoginUrl = () => {
  return apiUrl + '/auth/login';
};
export const LogoutUrl = () => {
  return apiUrl + '/auth/logout';
};
export const GetMeUrl = () => {
  return apiUrl + '/users/me';
};
export const getSecondaryPermissionsUrl = () => {
  return apiUrl + '/secondary-permissions/get-secondary-permissions';
};
export const DealerCompanyBaseProductPriceUrl = () => {
  return apiUrl + '/product-prices/get-company-base-product-price';
};
export const AllStateUrl = () => {
  return apiUrl + '/onboarding/get/all-state';
};
export const AllCityUrl = () => {
  return apiUrl + '/onboarding/get/all_district';
};
export const SendOTPByPhoneUrl = () => {
  return apiUrl + '/auth/send-otp-request-by-user-phone';
};
export const LoginOtpUrl = () => {
  return apiUrl + '/auth/login-by-otp';
};
export const SetNewPasswordUrl = () => {
  return apiUrl + '/auth/set-new-password';
};
